import { Fragment } from 'react';
import { Trans } from '@lingui/react/macro';
import { Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function MenuFooter(props) {
    const { withoutBorder = false, onSave, onClear } = props;
    const saveItem = (<Menu.Item onClick={onSave}>
      <Falcon icon="floppy-disk"/>
      <Trans comment="Bulk action: Metadata - Save property button label">Save value</Trans>
    </Menu.Item>);
    const clearItem = (<Menu.Item onClick={onClear}>
      <Falcon icon="trash"/>
      <Trans comment="Bulk action: Metadata - Clear property button label">Clear value</Trans>
    </Menu.Item>);
    if (withoutBorder) {
        return (<Fragment>
        {onSave && saveItem}
        {onClear && clearItem}
      </Fragment>);
    }
    return (<Menu.Footer sticky withoutPadding>
      {onSave && saveItem}
      {onClear && clearItem}
    </Menu.Footer>);
}
